<input
  #fileUpload
  type="file"
  hidden
  (change)="onFileChange($event)"
  [multiple]="multiple"
  [disabled]="disabled"
  [required]="required"
  [accept]="accept"
  [attr.capture]="capture || null"
/>

<ng-container *ngIf="size === 'lg'; else sm">
  <ng-container *ngIf="!multiple; else multipleFilesTemplate">
    <ng-container *ngTemplateOutlet="uploadAreaLarge; context: { fileConfig: filesConfig[0], showUpload: false }">
    </ng-container>
  </ng-container>

  <ng-template #multipleFilesTemplate>
    <ng-container *ngTemplateOutlet="uploadAreaMultiple"></ng-container>
  </ng-template>
</ng-container>

<ng-template #sm>
  <ng-container *ngIf="!multiple; else multipleFilesTemplate">
    <ng-container
      *ngTemplateOutlet="uploadAreaSmall; context: { fileConfig: filesConfig[0], index: 0, showUpload: false }"
    >
    </ng-container>
  </ng-container>

  <ng-template #multipleFilesTemplate>
    <ng-container *ngTemplateOutlet="uploadAreaMultiple"></ng-container>
  </ng-template>
</ng-template>

<ng-template #uploadAreaMultiple>
  <div class="upload-area-multiple">
    <ng-container *ngIf="size === 'lg'">
      <ng-container
        *ngTemplateOutlet="
          uploadAreaLarge;
          context: { showUpload: true, disabledUpload: maxFiles && filesConfig.length == maxFiles }
        "
      >
      </ng-container>
    </ng-container>
    <ng-container *ngIf="size === 'sm'">
      <ng-container
        *ngTemplateOutlet="
          uploadAreaSmall;
          context: { showUpload: true, disabledUpload: maxFiles && filesConfig.length == maxFiles }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngFor="let fileConfig of filesConfig; let i = index">
      <ng-container
        *ngIf="!hideFileList"
        [ngTemplateOutlet]="uploadAreaSmall"
        [ngTemplateOutletContext]="{ fileConfig: fileConfig, index: i, showUpload: false }"
      >
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #uploadAreaLarge
  let-fileConfig="fileConfig"
  let-showUpload="showUpload"
  let-disabledUpload="disabledUpload"
>
  <div
    class="upload-area upload"
    [class.upload-dropzone]="(filesConfig?.length === 0 || showUpload) && !required"
    [class.ds-bg-gray-200]="fileConfig?.alreadyUploaded"
    tabindex="0"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (paste)="onPaste($event)"
    [class.hover-dropzone]="hover_dropzone"
    [class.disabled]="disabled || disabledUpload"
  >
    <ng-container *ngIf="filesConfig?.length === 0 || showUpload">
      <ng-container
        *ngTemplateOutlet="
          textContainerLarge;
          context: {
            titleDesktop: title,
            titleMobile: displayTitleMobile,
            description: description,
            maxFiles: multiple && maxFiles ? maxFiles : '',
            icon: required ? 'warning-line' : uploadIcon,
            status: required ? 'error' : 'upload'
          }
        "
      ></ng-container>
      <ds-button
        class="lg"
        color="primary"
        [size]="btnSize$ | async"
        [label]="uploadButtonLabel"
        width="full"
        (click)="fileUpload.click()"
      ></ds-button>
    </ng-container>

    <ng-container *ngIf="filesConfig.length > 0 && !error && !fileConfig?.error && !showUpload">
      <ng-container
        *ngTemplateOutlet="
          textContainerLarge;
          context: {
            titleDesktop: fileConfig.file.name,
            titleMobile: fileConfig.file.name,
            description: fileConfig?.alreadyUploaded ? alreadyUploadedMessage : successMessage,
            icon: successIcon,
            status: successIconType
          }
        "
      ></ng-container>
      <div class="d-flex flex-column ds-gap-base w-100">
        <ds-button
          *ngIf="!hidePreview"
          color="secondary"
          [size]="btnSizeSmall$ | async"
          label="Ver documento"
          dsIcon="eye-line"
          width="full"
          (click)="previewFile(0)"
        ></ds-button>
        <ds-button
          *ngIf="(!fileConfig?.alreadyUploaded || showReplaceForUploaded) && !hideReplace"
          color="secondary"
          [size]="btnSizeSmall$ | async"
          label="Reemplazar"
          dsIcon="replace"
          width="full"
          (click)="fileUpload.click()"
        ></ds-button>
        <ds-button
          *ngIf="!hideDelete"
          color="secondary"
          [size]="btnSizeSmall$ | async"
          label="Eliminar"
          [dsIcon]="deleteIcon"
          width="full"
          state="error"
          (click)="clearFile()"
        ></ds-button>
      </div>
    </ng-container>

    <ng-container *ngIf="filesConfig.length > 0 && (error || fileConfig?.error) && !showUpload">
      <ng-container
        *ngTemplateOutlet="
          textContainerLarge;
          context: { titleDesktop: errorMessage, titleMobile: errorMessage, icon: 'exclamation-line', status: 'error' }
        "
      ></ng-container>
      <div class="d-flex ds-gap-base w-100">
        <ds-button
          color="primary"
          [size]="btnSize$ | async"
          [label]="errorButtonLabel"
          width="full"
          (click)="fileUpload.click()"
        ></ds-button>
        <ds-button
          *ngIf="enableRetry"
          color="secondary"
          [size]="btnSize$ | async"
          [label]="retryLabel"
          width="full"
          (click)="retryUpload(0)"
        ></ds-button>
      </div>
    </ng-container>

    <ng-container *ngIf="filesConfig.length > 0 && (loading || fileConfig?.loading) && !showUpload">
      <div class="loader-overlay">
        <ds-loader></ds-loader>
        <span *ngIf="loadingText" class="title">{{ loadingText }}</span>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #textContainerLarge
  let-titleDesktop="titleDesktop"
  let-titleMobile="titleMobile"
  let-description="description"
  let-icon="icon"
  let-status="status"
  let-maxFiles="maxFiles"
>
  <div class="text-container">
    <mat-icon [svgIcon]="icon" class="icon" [ngClass]="status"></mat-icon>
    <span class="title">{{ isMobile ? titleMobile : titleDesktop }}</span>
    <span class="description" *ngIf="description">{{ description }}</span>
    <span class="max-files" *ngIf="maxFiles">Máximo {{ maxFiles }} archivos permitidos</span>
  </div>
</ng-template>

<ng-template
  #uploadAreaSmall
  let-index="index"
  let-fileConfig="fileConfig"
  let-showUpload="showUpload"
  let-disabledUpload="disabledUpload"
>
  <div
    class="upload-area upload-area-sm"
    [class.upload]="(filesConfig.length === 0 || showUpload) && !required"
    [class.upload-dropzone]="(filesConfig.length === 0 || showUpload) && !required"
    [class.ds-bg-gray-200]="fileConfig?.alreadyUploaded"
    tabindex="0"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (paste)="onPaste($event)"
    (click)="onEmptyAreaClick($event, showUpload, disabledUpload)"
    [class.hover-dropzone]="hover_dropzone"
    [class.loading]="loading || fileConfig?.loading"
    [class.disabled]="disabled || disabledUpload"
  >
    <ng-container *ngIf="filesConfig.length === 0 || showUpload">
      <ng-container
        *ngTemplateOutlet="
          textContainerSm;
          context: {
            titleDesktop: title,
            titleMobile: displayTitleMobile,
            description: description,
            maxFiles: multiple && maxFiles ? maxFiles : '',
            icon: required ? 'warning-line' : uploadIcon,
            status: required ? 'error' : 'upload'
          }
        "
      ></ng-container>
      <ds-button
        *ngIf="uploadButtonLabel"
        class="sm"
        color="primary"
        [size]="btnSizeSmall$ | async"
        [label]="uploadButtonLabel"
        width="full"
        (click)="fileUpload.click()"
      ></ds-button>
    </ng-container>

    <ng-container
      *ngIf="filesConfig.length > 0 && !error && !loading && !fileConfig?.error && !fileConfig?.loading && !showUpload"
    >
      <ng-container
        *ngTemplateOutlet="
          textContainerSm;
          context: {
            titleDesktop: fileConfig.file.name,
            titleMobile: fileConfig.file.name,
            description: fileConfig?.alreadyUploaded ? alreadyUploadedMessage : successMessage,
            icon: successIcon,
            status: successIconType,
            descriptionStatus: successIconType
          }
        "
      ></ng-container>
      <div *ngIf="labeledActions" class="upload-area-sm__actions d-flex align-items-center gap-2 flex-shrink-0">
        <ds-button
          *ngIf="!hidePreview"
          color="tertiary"
          [size]="btnSizeSmall$ | async"
          [label]="previewLabel"
          dsIcon="eye-line"
          (click)="previewFile(index)"
        ></ds-button>
        <ds-button
          *ngIf="(!fileConfig?.alreadyUploaded || showReplaceForUploaded) && !hideReplace"
          color="tertiary"
          [size]="btnSizeSmall$ | async"
          [label]="replaceLabel"
          dsIcon="replace"
          (click)="replaceFile(index)"
        ></ds-button>
        <ds-button
          *ngIf="!hideDelete"
          color="tertiary"
          [size]="btnSizeSmall$ | async"
          [label]="deleteLabel"
          [dsIcon]="deleteIcon"
          state="error"
          (click)="removeFile(index)"
        ></ds-button>
      </div>

      <ng-container *ngIf="!labeledActions">
        <ds-icon
          *ngIf="!hidePreview"
          icon="eye-line"
          width="24px"
          height="24px"
          type="info"
          style="cursor: pointer"
          (click)="previewFile(index)"
          dsTooltip="Ver documento"
        >
        </ds-icon>
        <mat-icon
          *ngIf="(!fileConfig?.alreadyUploaded || showReplaceForUploaded) && !hideReplace"
          svgIcon="replace"
          class="icon-action replace"
          (click)="replaceFile(index)"
          [dsTooltip]="replaceLabel"
        ></mat-icon>
        <mat-icon
          *ngIf="!hideDelete"
          [svgIcon]="deleteIcon"
          class="icon-action trash"
          (click)="removeFile(index)"
          [dsTooltip]="deleteLabel"
        ></mat-icon>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="filesConfig.length > 0 && (error || fileConfig?.error) && !loading && !fileConfig?.loading && !showUpload"
    >
      <ng-container
        *ngTemplateOutlet="
          textContainerSm;
          context: {
            titleDesktop: fileConfig.file.name,
            titleMobile: fileConfig.file.name,
            description: errorMessage,
            icon: 'warning-line',
            status: 'error',
            descriptionStatus: 'error'
          }
        "
      ></ng-container>
      <mat-icon
        *ngIf="enableRetry"
        svgIcon="refresh"
        class="icon-action error"
        (click)="retryUpload(index)"
        [dsTooltip]="retryLabel"
      ></mat-icon>
      <mat-icon
        [svgIcon]="deleteIcon"
        class="icon-action trash"
        (click)="removeFile(index)"
        [dsTooltip]="deleteLabel"
      ></mat-icon>
    </ng-container>

    <ng-container *ngIf="filesConfig.length > 0 && (loading || fileConfig?.loading) && !showUpload">
      <ng-container
        *ngTemplateOutlet="
          textContainerSm;
          context: {
            titleDesktop: fileConfig.file.name,
            titleMobile: fileConfig.file.name,
            description: loadingText,
            icon: 'file-line',
            status: 'loading'
          }
        "
      ></ng-container>
      <ds-loader class="sm"></ds-loader>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #textContainerSm
  let-titleDesktop="titleDesktop"
  let-titleMobile="titleMobile"
  let-description="description"
  let-icon="icon"
  let-status="status"
  let-descriptionStatus="descriptionStatus"
  let-maxFiles="maxFiles"
>
  <div class="text-container text-container-sm">
    <mat-icon [svgIcon]="icon" class="icon icon-sm" [ngClass]="status"></mat-icon>
    <div class="title-container">
      <span class="title title-sm">{{ isMobile ? titleMobile : titleDesktop }}</span>
      <span class="description description-sm" *ngIf="description" [ngClass]="descriptionStatus">{{
        description
      }}</span>
      <span class="max-files max-files-sm" *ngIf="maxFiles">Máximo {{ maxFiles }} archivos permitidos</span>
    </div>
  </div>
</ng-template>
